/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-cta-shared-styles">
	<template>
		<custom-style>
			<style>
                .ctas {
                    align-items: flex-start;
                    display: flex;
                    flex-flow: column wrap;
                    justify-content: flex-start
                }

                :host([text-align=center]) .ctas {
                    align-items: center;
                    justify-content: center
                }

                :host([text-align=right]) .ctas {
                    align-items: flex-end;
                    justify-content: flex-end
                }

                @media only screen and (min-width:768px) {
                    .ctas {
                        flex-direction: row
                    }
                }

                .d1:not([hidden])+.ctas,
                .d1:not([hidden])+[hidden]+.ctas,
                .d1:not([hidden])+[hidden]+[hidden]+.ctas {
                    margin-top: 15px
                }

                .d2:not([hidden])+.ctas,
                .d2:not([hidden])+[hidden]+.ctas,
                .d2:not([hidden])+[hidden]+[hidden]+.ctas {
                    margin-top: 15px
                }

                .d3:not([hidden])+.ctas,
                .d3:not([hidden])+[hidden]+.ctas,
                .d3:not([hidden])+[hidden]+[hidden]+.ctas {
                    margin-top: 16px
                }

                .d4:not([hidden])+.ctas {
                    margin-top: 17px
                }

                .h4:not([hidden])+.ctas,
                .h4:not([hidden])+[hidden]+.ctas {
                    margin-top: 15px
                }

                .h5:not([hidden])+.ctas,
                .h5:not([hidden])+[hidden]+[hidden]+[hidden]+.ctas {
                    margin-top: 24px
                }

                .h6:not([hidden])+.ctas {
                    margin-top: 24px
                }

                .b2:not([hidden])+.ctas,
                .b2:not([hidden])+[hidden]+.ctas {
                    margin-top: 17px
                }

                .b3:not([hidden])+.ctas,
                .b3:not([hidden])+[hidden]+[hidden]+.ctas {
                    margin-top: 18px
                }

                img+dom-if+.ctas,
                img+dom-if+[hidden]+.ctas,
                img+dom-if+[hidden]+[hidden]+.ctas {
                    margin-top: 32px
                }

                @media only screen and (min-width:768px) {

                    .d1:not([hidden])+.ctas,
                    .d1:not([hidden])+[hidden]+.ctas,
                    .d1:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 18px
                    }

                    .d2:not([hidden])+.ctas,
                    .d2:not([hidden])+[hidden]+.ctas,
                    .d2:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 22px
                    }

                    .d3:not([hidden])+.ctas,
                    .d3:not([hidden])+[hidden]+.ctas,
                    .d3:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 24px
                    }

                    .d4:not([hidden])+.ctas {
                        margin-top: 25px
                    }

                    .h4:not([hidden])+.ctas,
                    .h4:not([hidden])+[hidden]+.ctas {
                        margin-top: 23px
                    }
                }

                @media only screen and (min-width:1024px) {

                    .d1:not([hidden])+.ctas,
                    .d1:not([hidden])+[hidden]+.ctas,
                    .d1:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 22px
                    }

                    .d2:not([hidden])+.ctas,
                    .d2:not([hidden])+[hidden]+.ctas,
                    .d2:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 26px
                    }

                    .d3:not([hidden])+.ctas,
                    .d3:not([hidden])+[hidden]+.ctas,
                    .d3:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 32px
                    }

                    .d4:not([hidden])+.ctas {
                        margin-top: 33px
                    }

                    .h4:not([hidden])+.ctas,
                    .h4:not([hidden])+[hidden]+.ctas {
                        margin-top: 30px
                    }

                    .h5:not([hidden])+.ctas,
                    .h5:not([hidden])+[hidden]+[hidden]+[hidden]+.ctas {
                        margin-top: 27px
                    }

                    .h6:not([hidden])+.ctas {
                        margin-top: 28px
                    }

                    .b2:not([hidden])+.ctas,
                    .b2:not([hidden])+[hidden]+.ctas {
                        margin-top: 21px
                    }

                    .b3:not([hidden])+.ctas,
                    .b3:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 22px
                    }

                    img+dom-if+.ctas,
                    img+dom-if+[hidden]+.ctas,
                    img+dom-if+[hidden]+[hidden]+.ctas {
                        margin-top: 40px
                    }
                }

                @media only screen and (min-width:1456px) {

                    .d1:not([hidden])+.ctas,
                    .d1:not([hidden])+[hidden]+.ctas,
                    .d1:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 25px
                    }

                    .d2:not([hidden])+.ctas,
                    .d2:not([hidden])+[hidden]+.ctas,
                    .d2:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 33px
                    }

                    .d3:not([hidden])+.ctas,
                    .d3:not([hidden])+[hidden]+.ctas,
                    .d3:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 38px
                    }

                    .d4:not([hidden])+.ctas {
                        margin-top: 40px
                    }

                    .h4:not([hidden])+.ctas,
                    .h4:not([hidden])+[hidden]+.ctas {
                        margin-top: 37px
                    }

                    .h5:not([hidden])+.ctas,
                    .h5:not([hidden])+[hidden]+[hidden]+[hidden]+.ctas {
                        margin-top: 31px
                    }

                    .h6:not([hidden])+.ctas {
                        margin-top: 31px
                    }

                    .b2:not([hidden])+.ctas,
                    .b2:not([hidden])+[hidden]+.ctas {
                        margin-top: 24px
                    }

                    .b3:not([hidden])+.ctas,
                    .b3:not([hidden])+[hidden]+[hidden]+.ctas {
                        margin-top: 25px
                    }

                    img+dom-if+.ctas,
                    img+dom-if+[hidden]+.ctas,
                    img+dom-if+[hidden]+[hidden]+.ctas {
                        margin-top: 48px
                    }
                }
            </style>
			<custom-style>
			</template>
		</dom-module>`;

document.head.appendChild($_documentContainer.content);